import { useKeycloak } from '@react-keycloak/web'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import API from '../api/Api'
import { publicRoutes } from '../api/components-examples/Routes/routes'
import { initializeReactGoogle, notifyGoogle } from '../api/components-examples/utils/commonUtilityFunctions'
import { signInRequest, signInSuccess } from '../api/redux/authActions'
import { setUserProfile, setUserToken } from '../api/redux/UserProfile'
import WaitingLoader from '../UI-components/Templates/WaitingLoader'

initializeReactGoogle({})
notifyGoogle('login_started')

const SignInRequired = props => {
  const { keycloak, initialized } = useKeycloak()
  const [timerId, setTimerId] = useState(null)


  const checkFirstLogin = () => {
    const isFirstLogin = !localStorage.getItem('isEmlyUserLoggedIn')  // Check flag
    // Set flag so next time it's treated as a reload
    localStorage.setItem('isEmlyUserLoggedIn', 'true')
    if (isFirstLogin) {
      localStorage.setItem('AUTOMATIC_UBER_UP', 'true')
    }
  }

  useEffect(() => {
    if (initialized) {
      props.dispatch(signInRequest(keycloak))
    }
    if (keycloak.authenticated) {
      try {
        const userInfo = {
          email: JSON.parse(atob(keycloak.token.split('.')[1])).email
        }

        initializeReactGoogle(userInfo)
        notifyGoogle('login_successfull')
      } catch (error) { }

      props.dispatch(signInSuccess(keycloak))
      props.dispatch(API.createInitAPIAction())
      props.dispatch(setUserToken(keycloak))
      props.dispatch(setUserProfile(JSON.parse(atob(keycloak.token.split('.')[1]))))
      window.localStorage.setItem('userID', JSON.parse(atob(keycloak.token.split('.')[1])).sub)

      checkFirstLogin()

      const scheduleTokenCheck = () => {
        // Function to check if the token is near expiration and refresh it
        const checkToken = () => {
          keycloak
            .updateToken(10)
            .then(refreshed => {
              if (refreshed) {
                console.log('Token was successfully refreshed')
              } else {
                console.warn('Token is still valid')
              }
              scheduleNextCheck()
            })
            .catch(() => {
              console.error('Failed to refresh the token, or the session has expired')
            })
        }

        // Calculate time until the next token expiration
        const scheduleNextCheck = () => {
          const timeUntilExpiry = (keycloak.tokenParsed.exp - Math.floor(Date.now() / 1000)) * 1000
          console.log(`Token will expire in ${timeUntilExpiry / 1000} seconds`)
          setTimerId(setTimeout(checkToken, timeUntilExpiry - 10000)) // Check 10 seconds before expiration
        }

        // Initial token check
        scheduleNextCheck()
      }

      // Schedule the first token check
      scheduleTokenCheck()
    }
    if (initialized && !keycloak.authenticated && !publicRoutes.includes(props.location.pathname)) {
      keycloak.login()
      return null
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId)
      }
    }
  }, [initialized, keycloak])

  const currentUrl = window.location.href
  const signup = currentUrl.search('signup') !== -1

  if (initialized && keycloak.authenticated === false && signup === false) {
    keycloak.login()
  }

  if (keycloak) {
    if (keycloak.authenticated) {
      return props.children
    } else {
      return <WLoader />
    }
  }

  return <WLoader />
}

export default connect(state => state)(SignInRequired)

export const WLoader = ({ text }) => {
  return (
    <div className="centreLoadingSpinner" style={{ height: 'calc( 100vh - 50px )' }}>
      <WaitingLoader message={'Please wait we are loading your assets.....'} />
    </div>
  )
}


export const Loader = ({ text }) => {
  return (
    <div className="centreLoadingSpinner" style={{ height: 'calc( 100vh - 50px )' }}>
      <h3>{text}</h3>
      <img src={require('../../src/images/onBoard/Loading Bar.gif')} style={{ width: 200, height: 200 }} />
    </div>
  )
}
